<template>
  <div class="ang-card ang-card">
    <div class="ang-card-body">
      <div class="alert alert-success ang-alert-success mt-3">
        <h5 class="ang-card-title">Dziękujemy za wypełnienie formularza</h5>
        <div>
          <div v-if="signal">
            <p>
              Twoje dane i zgody zostały z powodzeniem zapisane w naszej bazie.
            </p>
            <div>
              <span
                >Na Twój adres e-mail wysłaliśmy podsumowanie wypełnienia
                formularza zawierające wprowadzone dane oraz udzielone
                zgody.</span
              >
            </div>
          </div>
          <div v-else-if="base">
            <p>Twoje dane i zgody zostały zaktualizowane.</p>
            <div v-if="solicitor">
              <span
                >Na Twój adres e-mail wysłaliśmy podsumowanie wypełnienia
                formularza zawierające wprowadzone dane, udzielone zgody oraz
                dane kontaktowe Twojego eksperta.</span
              >
            </div>
            <div v-else>
              <span
                >Na Twój adres e-mail wysłaliśmy podsumowanie wypełnienia
                formularza zawierające wprowadzone dane oraz udzielone
                zgody.</span
              >
            </div>
          </div>
          <div v-else>
            <p>
              Twoje dane i zgody zostały z powodzeniem zapisane w naszej bazie.
            </p>
            <div v-if="solicitor">
              <span
                >Na Twój adres e-mail wysłaliśmy podsumowanie wypełnienia
                formularza zawierające wprowadzone dane, udzielone zgody oraz
                dane kontaktowe Twojego eksperta.</span
              >
            </div>
            <div v-else>
              <span
                >Na Twój adres e-mail wysłaliśmy podsumowanie wypełnienia
                formularza zawierające wprowadzone dane oraz udzielone zgody.
                Jeden z naszych ekspertów skontaktuje się z Tobą najpóźniej w
                ciągu dwóch dni roboczych w celu przygotowania oferty. Jeżeli
                masz już wybranego eksperta ANG, podaj mu poniższy kod:</span
              >
              <h5 class="ang-heading mt-3">{{ code }}</h5>
            </div>
          </div>
        </div>
      </div>
      <div v-if="signal && data && data.url" class="text-center">
        <a
          :href="data.url"
          target="_blank"
          class="btn ang-button ang-btn-lg _bg_color3 mt-4 text-nowrap"
          >DOKOŃCZ ZAKUP
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: ["base", "solicitor", "code", "signal", "data"],
};
</script>
